// Options for URL query string serialization: repeated arrays, encode only values
export const QUERY_STRING_OPTIONS = {
  encodeValuesOnly: true,
  arrayFormat: "repeat",
} as const;

// Options for URL query string serialization of image arrays: comma-separated values
export const QUERY_STRING_OPTIONS_IMAGES = {
  encodeValuesOnly: true,
  arrayFormat: "comma",
} as const;

// Common image fields used across CMS responses and GraphQL queries
export const IMAGE_FIELDS = [
  "name",
  "alternativeText",
  "caption",
  "width",
  "height",
  "formats",
  "ext",
  "mime",
  "size",
  "cloudflare_url",
  "url",
  "previewUrl",
];
